import React , {useState} from 'react';
import PropTypes from 'prop-types';

function Form({consultData}) {
 
    //search = state , setSearch = this.setState
    const[search,setSearch] = useState({
        city:'',
        country:''
    })

    const handleChange = e => {
        //cambiar el state
        setSearch({
            ...search,
            [e.target.name] : e.target.value
        });
        //console.log(search);
    }

    const consultWeather = e => {
        e.preventDefault();
        // pasar hacia componente principal la busqueda
        consultData(search);
    }

    

    return (
        <form
            onSubmit={consultWeather}    
        >
            <div className="input-field col s12">
                <input
                    type="text"
                    name="city"
                    id="city"
                    onChange={handleChange}
                />
                <label htmlFor="city">Ciudad: </label>
            </div>
            <div className="input-field col s12">
                <select onChange={handleChange} name="country"> 
                    <option value="">Selecciona un país</option>
                    <option value="CL">Chile</option>
                    <option value="VE">Venezuela</option>
                    <option value="US">Estados Unidos</option>
                    <option value="MX">México</option>
                    <option value="AR">Argentina</option>
                    <option value="CO">Colombia</option>
                    <option value="ES">España</option>
                    <option value="CR">Costa Rica</option>
                    <option value="PE">Peru</option>
                </select>
            </div>

            <div className="input-field col s12">
                <input 
                    type="submit" 
                    className="waves-effect waves-light btn-large btn-block yellow accent-4"
                    value="Buscar Clima"
                />
            </div>

        </form>
    )
}
Form.propTypes = {
    consultData: PropTypes.func.isRequired
}
export default Form;